import { Dispatch, SetStateAction, useCallback } from 'react'

export default function useOnInputChange<T>(setState: Dispatch<SetStateAction<T>>) {
  return useCallback(
    function(event) {
      const target = event.target
      const value = target.type === 'checkbox' ? target.checked : target.value
      const name = target.name
      setState(current => ({ ...current, [name]: value }))
    },
    [setState]
  )
}
